import store from './../store'

function hasRole (roles) {
  if (!store.state.user) {
    return false
  }
  return store.state.user.roles.some(role => roles.includes(role))
}

const hasRolePlugin = {
  install: (app) => {
    app.config.globalProperties.$hasRole = hasRole
  }
}

export { hasRole }
export default hasRolePlugin
